import { render, staticRenderFns } from "./Unsaved.vue?vue&type=template&id=06ae9eef&scoped=true&"
import script from "./Unsaved.vue?vue&type=script&lang=js&"
export * from "./Unsaved.vue?vue&type=script&lang=js&"
import style0 from "./Unsaved.vue?vue&type=style&index=0&id=06ae9eef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae9eef",
  null
  
)

export default component.exports